import { createAsyncThunk, createSlice, type PayloadAction } from "@reduxjs/toolkit";
// import { getData, postData } from "../../../Axios/axiosData";
import type { Parameters } from "./reportModels";
import { ntxAPI } from "../../../../API/axiosNeatex";




export const GetParametersByReportId = createAsyncThunk(
    "ReportData/GetParametersByReportId",
    async (id : string, thunkAPI) => {
      const { rejectWithValue } = thunkAPI;
  
      try {
        // const data = await getData(`Reports/GeParametersByReportId?ReportId=${id}`);
        const {data} = await ntxAPI.get(`Reports/GeParametersByReportId?ReportId=${id}` );
        return data.data;
      } catch (error : any) {
        console.error(error);
        return rejectWithValue(error.message);
      }
    }
  )


  
export const GetReportsData = createAsyncThunk(
    "ReportData/GetReportsData",
    async (item : object, thunkAPI) => {
      const { rejectWithValue } = thunkAPI;
      try {
        // const data = await postData("Reports/GetReportsData" , item);
        const {data} = await ntxAPI.post( "Reports/GetReportsData", item)
        return data;
      } catch (error : any) {
        // console.error(error);
        return rejectWithValue(error.message);
      }
    }
  )
  
export const GetReportsChartData = createAsyncThunk(
    "ReportData/GetReportsChartData",
    async (item : object, thunkAPI) => {
      const { rejectWithValue } = thunkAPI;
      
      try {
        const {data} = await ntxAPI.post("Reports/GetReportsChartData" , item)
        return data;
      } catch (error : any) {
        // console.error(error);
        return rejectWithValue(error.message);
      }
    }
  )



interface ParameterState {
    loading: boolean;
    loadingGetReportsData: boolean;
    error: string | null;
    ParameterList: Parameters ;
    ReportsDataList : object | null
  }
  
  const initialState = {
    loading: false,
    loadingGetReportsData: false,
    error: null,
    ParameterList : {} as Parameters,
    ReportsDataList : null
  } as ParameterState


  const reportdataSlice = createSlice({
    name: "ReportData",
    initialState,
    reducers: {},
    extraReducers(builder) {
      builder
        .addCase(GetParametersByReportId.pending, (state) => {
          state.loading = true;
          if (state.ParameterList) {
            state.ParameterList.parameterList = [];
          }
        })
        .addCase(GetParametersByReportId.fulfilled, (state, action: PayloadAction<Parameters>) => {
          state.loading = false;
          state.ParameterList = action.payload;
        })
        .addCase(GetParametersByReportId.rejected, (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload;
        })
        

        .addCase(GetReportsData.pending, (state) => {
          state.loadingGetReportsData = true;
        })
        .addCase(GetReportsData.fulfilled, (state, action:PayloadAction<any> ) => {
          state.loadingGetReportsData = false;
          state.ReportsDataList = action.payload;
        })
        .addCase(GetReportsData.rejected, (state, action: PayloadAction<any>) => {
          state.loadingGetReportsData = false;
          state.error = action.payload;
        })



        

        .addCase(GetReportsChartData.pending, (state) => {
          state.loadingGetReportsData = true;
        })
        .addCase(GetReportsChartData.fulfilled, (state ) => {
          state.loadingGetReportsData = false;
          // state.ReportsDataList = action.payload;
        })
        .addCase(GetReportsChartData.rejected, (state, action: PayloadAction<any>) => {
          state.loadingGetReportsData = false;
          state.error = action.payload;
        });
    },
  });
  
  export default reportdataSlice.reducer;